<div class="self-assessment-footer" [ngClass]="{'last': isLast}">
  <button role="button" class="self-assessment-footer__clear" (click)="clearPage()" [ngClass]="{'hidden': currentPageSelfAssessmentsActiveNumber === 0}">
    <span class="self-assessment-footer__clear-title">Auswahl löschen</span> <span class="self-assessment-footer__clear-number">{{currentPageSelfAssessmentsActiveNumber}}</span>
  </button>

  <div class="self-assessment-footer__nav">
    <div class="self-assessment-footer__nav-item self-assessment-footer__nav-item--prev">
      <brt-button [title]="'Zurück'" [before-icon]="'reg-chevron-left'" [color]="'river'" [size]="'large'" [disabled]="isFirst" (click)="goPrev()"></brt-button>
    </div>

    <div class="self-assessment-footer__nav-item self-assessment-footer__nav-item--done">
      <brt-button [title]="'Berufe anzeigen'" [after-icon]="'reg-chevron-right'" [color]="'river'" [size]="'large'" (click)="endAssessment()"></brt-button>
    </div>

    <div class="self-assessment-footer__nav-item self-assessment-footer__nav-item--next" >
      <brt-button [title]="'Weiter'" [after-icon]="'reg-chevron-right'" [color]="'river'" [size]="'large'" (click)="goNext()"></brt-button>
    </div>
  </div>
</div>
